<template>
  <!-- ケアオーケストレーター施設管理 -->
  <div id="HospitalContents">
      <div class="labelTitle lable">ケア オーケストレーター　施設管理</div>
      <div id="item-contens">
        <div class="card-content margin-top">
          <table>
              <tr><th>申込み状況</th>
                  <td><span :class="getTagClass4CoInternalUserStatus(data.status)" style="width:150px;">{{data.status | coInternalStatusFilter}}</span></td>
              </tr>
              <tr><th>医療機関名</th><td>{{data.medicalInstitutionName}}</td></tr>
              <tr><th>診療科</th><td>{{data.department}}</td></tr>
              <tr><th>担当支店</th><td>{{data.branchOfficeName}}</td></tr>
              <tr><th>郵便番号</th><td>{{data.postcode}}</td></tr>
              <tr><th>都道府県</th><td>{{data.prefecture}}</td></tr>
              <tr><th>市町村</th><td>{{data.city}}</td></tr>
              <tr><th>住所1</th><td>{{data.address1}}</td></tr>
              <tr><th>住所2</th><td>{{data.address2}}</td></tr>
              <tr><th>電話番号</th><td>{{data.telephone}}</td></tr>
              <tr><th>クライアント認証</th><td><span v-if="data.certificationFlag">有効にする</span><span v-else>有効にしない</span></td></tr>
              <tr v-if="!data.isDealer">
                <th>ケア　エクスポーター</th>
                <td>
                  <span v-if="data.careExporter">有効にする</span><span v-else>有効にしない</span>
                </td>
              </tr>
              <tr v-if="data.isDealer"><th>フィリップス保守サービス</th><td><span v-if="data.crossReferenceFlag">有</span><span v-else>無</span></td></tr>
              <tr><th>備考</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.note}}</td></tr>
          </table>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HospitalContents",
  methods: {
    doSearch: function() {
      var excuteApi = this.getCoHospitalContentsPOST;
      var successCallBack = this.getCoHospitalContentsPOSTSuccess;
      var errorCallBack = this.getCoHospitalContentsPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getCoHospitalContentsPOST: function(client) {
      return client.apis.internalCoSetting.getCoHospitalContentsPOST({
        body:{
          careOrchestratorInstitutionId: this.careOrchestratorInstitutionId
        }
      });
    },
    getCoHospitalContentsPOSTSuccess: function(result) {
        // 検索結果取得
        this.data = result.obj
    },
    getCoHospitalContentsPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    }
  },
  data() {
    let careOrchestratorInstitutionId = this.$route.params["careOrchestratorInstitutionId"];
    return {
      data: {},
      careOrchestratorInstitutionId:careOrchestratorInstitutionId,
    };
  },
  async mounted() {
    await this.doSearch();
  },
  filters: {},
  components: {
  },
};
</script>
<style lang="scss" scoped>
.urgency_caution {
    color: red;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/philips/careorchestrator/setting/HospitalContents.vue